<!--
 * @Autor: GeekMzy
 * @Date: 2022-08-11 15:38:16
 * @LastEditors: WIN-2KU5SQ4208L
 * @LastEditTime: 2023-02-14 14:22:44
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\Dialog\DialogVideoInfoHK.vue
 * @Author: desktop-1llkr2o
-->
<!-- 视频信息弹框 -->
<template>
  <div class="dialog-video-info">
    <div class="header">
      <div class="title">
        <select @change="changDevice">
          <option v-for="(item, index) in deviceList" :key="index">{{ item.deviceName }}</option>
        </select>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div ref="videoContainer" class="video-box">
          <!-- <video
            ref="video"
            controls
            autoplay
            class="video video-js vjs-default-skin vjs-big-play-centered"
          ></video> -->
          <!-- <video
            v-show="!deviceInfo.hkVideo"
            ref="video"
            controls
            autoplay
            class="video video-js vjs-default-skin vjs-big-play-centered"
          ></video>
          <div v-show="deviceInfo.hkVideo && tilt" id="play_window"></div>
          <VideoPlayerHk v-show="deviceInfo.hkVideo && !tilt" ref="videoPlayer"></VideoPlayerHk> -->
        </div>
        <div v-show="deviceInfo && deviceInfo.accessMode == 6 && tilt" class="btn-box">
          <div class="btn" :class="{ active: controlShow }" @click="control">云台控制</div>
        </div>
        <div v-show="controlShow" class="control">
          <span @click="directioControl('top')"></span>
          <span @click="directioControl('right')"></span>
          <span @click="directioControl('bottom')"></span>
          <span @click="directioControl('left')"></span>
          <div class="focal">
            <p @click="directioControl('enlarge')">+</p>
            <p @click="directioControl('narrow')">-</p>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">问题清单</div>
        <n-data-table
          max-height="530"
          :columns="columns"
          :data="tableData"
          :pagination="false"
          :bordered="false"
          :row-props="problemDetails"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Bus from '@/config/Bus'
import {
  h,
  toRefs,
  nextTick,
  getCurrentInstance,
  onMounted,
  onBeforeUnmount,
  defineEmits,
} from 'vue'
import Video from 'video.js'
import { useMessage } from 'naive-ui'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'
import VideoPlayerHk from '@/components/common/VideoPlayerHk.vue'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import { AnyLayout } from 'mapbox-gl'

const mainStore = useMainStore(pinia)

const videoPlayer = ref(null)
const props = defineProps({
  data: Object,
})
const api = new Api()
const message = useMessage()
const tilt = ref(false)
const columns = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '时间',
    key: 'reportTime',
    width: 120,
    align: 'center',
  },
  {
    title: '名称',
    key: 'problemName',
    align: 'center',
  },
  {
    title: '类别',
    key: 'aiTypeStr',
    width: 120,
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row, index) {
      let className = 'tag dcl'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => row.problemStatusStr,
        }
      )
    },
  },
])
const tableData = ref([])
const problemTypeObj = []
const controlShow = ref(false)
const multiplyShow = ref(false)
const params = {
  action: 1,
  command: 'UP',
}
const deviceList = ref([])
const deviceInfo = ref({
  hkVideo: true,
})
const videoContainer = ref()
const video = ref()
let customInterval = null
let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

// 获取问题列表
const getProblemList = () => {}
const getProblemTypeStr = (data1) => {
  for (let i = 0; i < problemTypeObj.length; i += 1) {
    if (parseInt(problemTypeObj[i].value, 10) === data1) {
      return problemTypeObj[i].name
    }
  }
  return ''
}
/**
 * @description: 获取视频信息
 * @event:
 * @param {*}
 * @return {*}
 */
const getVideo = () => {
  // eslint-disable-next-line no-undef
  console.log('getVideo', props.data)
  api.screen.getAiListByIdUsingPost({ id: props.data.id }).then((res) => {
    if (res.code === 200) {
      tableData.value = res.data
    }
  })
  setTimeout(() => {
    if (tilt.value) {
      api.screen.cameraWsStreamByIdUsingPost({ id: props.data.id }).then((res) => {
        if (res.code === 200) {
          deviceList.value = [res.data]
          deviceInfo.value = res.data
          deviceInfo.value.deviceName = props.data.name
          // if (deviceInfo.value.hkVideo && tilt.value) {
          //   const curIndex = 0 // 当前窗口下标
          //   // eslint-disable-next-line no-undef
          //   const myPlugin = new JSPlugin({
          //     szId: 'play_window', //需要英文字母开头 必填
          //     szBasePath: './', // 必填,引用H5player.min.js的js相对路径
          //   })
          //   let startTime, endTime
          //   myPlugin.JS_Play(
          //     deviceInfo.value.videoStream,
          //     {
          //       playURL: deviceInfo.value.videoStream, // 流媒体播放时必传
          //       mode: 0, // 解码类型：0=普通模式; 1=高级模式 默认为0
          //       // 设置直连时的认证参数等
          //       // ...
          //     },
          //     curIndex
          //   )
          // } else {
            if (player) {
              player.dispose()
            }
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%; height: 100%');
            video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
            video.setAttribute('id', 'pop_video');
            videoContainer.value.appendChild(video);
            setTimeout(() => {
              const option = {
                muted: false,
                controls: true,
                loop: false,
                autoplay: false,
                sources: [
                  {
                    type: '',
                    src: deviceInfo.value.videoStream, // url地址
                  },
                ],
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                // poster:,
                // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
              }
              // 初始化的时候标签默认都是显示的
              player = Video('pop_video', option, () => {
                player.on('error', () => {
                  player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
                  console.log('视频加载错误')
                })
              })
              player.play()
            }, 1000)
          }
        // }
      })
    } else {
      api.screen.getCameraStreamListByIdUsingPost({ id: props.data.id }).then((res) => {
        if (res.code === 200) {
          deviceList.value = res.data
          deviceInfo.value = res.data[0]
          // if (deviceInfo.value.hkVideo && !tilt.value) {
          //   console.log('deviceInfo.value.hkVideo ----------', videoPlayer.value)
          //   setTimeout(() => {
          //     videoPlayer.value.initPlugin(deviceInfo.value.deviceId)
          //   }, 1000)
          // } else {
            if (player) {
              player.dispose()
            }
            const video = document.createElement('video');
            video.setAttribute('style', 'width: 100%; height: 100%');
            video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
            video.setAttribute('id', 'pop_video');
            videoContainer.value.appendChild(video);
            setTimeout(() => {
              const option = {
                muted: false,
                controls: true,
                loop: false,
                autoplay: false,
                sources: [
                  {
                    type: '',
                    src: deviceInfo.value.videoStream, // url地址
                  },
                ],
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                // poster:,
                // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
              }
              // 初始化的时候标签默认都是显示的
              player = Video('pop_video', option, () => {
                player.on('error', () => {
                  player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
                  console.log('视频加载错误')
                })
              })
              player.play()
            }, 1000)
          }
        // }
      })
    }
  }, 500)
}

//切换设备
const changDevice = (e: any) => {
  // if (videoPlayer.value) {
  //   videoPlayer.value.stopAllPreview()
  // }
  // setTimeout(() => {
  //   if (player) {
  //     player.dispose()
  //   }
  // }, 200)
  deviceInfo.value = deviceList.value[e.target.selectedIndex]
  // if (deviceInfo.value.hkVideo && !tilt.value) {
  //   setTimeout(() => {
  //     videoPlayer.value.initPlugin(deviceInfo.value.deviceId)
  //   }, 100)
  // } else {
    setTimeout(() => {
      // if (player.src) {
      //   player.src({ src: deviceInfo.value.videoStream })
      // } else {
        if (player) {
          player.dispose()
        }
        const video = document.createElement('video');
        video.setAttribute('class', 'video video-js vjs-default-skin vjs-big-play-centered');
        video.setAttribute('style', 'width: 100%; height: 100%');
        video.setAttribute('id', 'pop_video');
        videoContainer.value.appendChild(video);
        const option = {
          muted: false,
          controls: true,
          loop: false,
          autoplay: false,
          sources: [
            {
              type: '',
              src: deviceInfo.value.videoStream, // url地址
            },
          ],
          notSupportedMessage: '此视频暂无法播放，请稍后再试',
          // poster:,
          // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
        }
        // 初始化的时候标签默认都是显示的
        player = Video('pop_video', option, () => {
          player.on('error', () => {
            player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
            console.log('视频加载错误')
          })
        })
      // }
      player.play()
    }, 1000)
  // }
}

// 云台控制
const control = () => {
  multiplyShow.value = false
  controlShow.value = !controlShow.value
}

/** 监控控制 */
const directioControl = (val) => {
  // console.log(val)
  // console.log(props.data)
  if (!deviceInfo.value.deviceId) {
    return
  }
  params.cameraIndexCode = deviceInfo.value.deviceId
  switch (val) {
    case 'stop':
      params.action = 1
      break
    case 'top':
      params.action = 0
      params.command = 'UP'
      break
    case 'right':
      params.action = 0
      params.command = 'RIGHT'
      break
    case 'bottom':
      params.action = 0
      params.command = 'DOWN'
      break
    case 'left':
      params.action = 0
      params.command = 'LEFT'
      break
    case 'enlarge':
      params.action = 0
      params.command = 'ZOOM_IN'
      break
    case 'narrow':
      params.action = 0
      params.command = 'ZOOM_OUT'
      break
    default:
  }
  api.screen.controllingUsingPost(params).then((res) => {
    // console.log(res)
    if (res.code == 500) {
      message.warning('该设备暂不支持此功能')
    }
  })
}

// 问题详情
const problemDetails = (row: any) => {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      // setTimeout(() => {
      //   if (videoPlayer.value) {
      //     videoPlayer.value.hideVideoPlayer()
      //   }
      // }, 200)
      // clearInterval(customInterval)
      // customInterval = setInterval(() => {
      //   if (videoPlayer.value) {
      //     videoPlayer.value.hideVideoPlayer()
      //   }
      // }, 200)
      Bus.emit('2showModal', {
        data: row,
        modalType: '问题详情',
      })
    },
  }
}

onMounted(() => {
  getVideo()
  // Bus.off('videoPlayer')
  // Bus.on('videoPlayer', () => {
  //   if (deviceInfo.value.hkVideo && !tilt.value) {
  //     clearInterval(customInterval)
  //     setTimeout(() => {
  //       videoPlayer.value.showVideoPlayer()
  //     }, 500)
  //   }
  // })
})

onBeforeUnmount(async () => {
  // Bus.off('videoPlayer')
  // clearInterval(customInterval)
  // if (videoPlayer.value) {
  //   videoPlayer.value.stopAllPreview()
  // }
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})
</script>
<style lang="scss">
::v-deep .n-message-container {
  background-color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
.dialog-video-info {
  text-align: left;

  .header {
    margin-bottom: 2rem;

    .title {
      line-height: 32px;
      font-size: 26px;

      select {
        color: #fff;
        display: block;
        height: 32px;
        line-height: 32px;
        font-size: 26px;
        background: #ffffff00;
        border: none;
        border-bottom: 1px solid #ddd;

        &:focus-visible {
          outline: none;
        }

        option {
          font-size: 18px;
          color: #ffffff;
          background: #0088bf;
        }
      }

      .select::-ms-expand {
        display: none;
      }
    }

    .btn {
      display: inline-block;
      color: #4fd2ff;
      font-size: 1.5rem;
      line-height: 2rem;
      padding: 0.5rem 1rem;
      border-radius: 0.1rem;
      margin: 0.6rem 0 0.6rem 1.2rem;
      border: 1px solid #4ec8da9e;
      background: #5dc3ce14;
      cursor: pointer;

      &.active {
        background: #2e68ff40;
        color: #ffffff;
      }
    }
  }

  .content {
    display: flex;

    .left {
      position: relative;

      .ar-list {
        position: absolute;
        top: 1rem;
        right: 1rem;
        z-index: 9;
        color: #ffffff;

        .title {
          width: 100%;
          height: 2rem;

          .bj-box {
            position: absolute;

            .bj1 {
              position: absolute;
              background: url('~@/assets/img/map/Rectangle5.png') 100% 100% no-repeat;
              width: 0.8rem;
              height: 1.05rem;
              top: 0.5rem;
              left: 0.2rem;
              z-index: 1;
            }

            .bj2 {
              position: absolute;
              background: url('~@/assets/img/map/Rectangle4.png') 100% 100% no-repeat;
              width: 14.2rem;
              height: 2rem;
            }

            .bj3 {
              position: absolute;
              background: url('~@/assets/img/map/Rectangle6.png') 100% 100% no-repeat;
              width: 14.2rem;
              height: 1.05rem;
            }
          }

          p {
            position: absolute;
            padding-left: 1.3rem;
            font-size: 1.2rem;
            line-height: 2rem;
            margin: 0;
          }
        }

        ul {
          box-sizing: border-box;
          margin-top: 0.5rem;
          border-bottom: 0.1rem solid transparent;
          border-image: url('~@/assets/img/map/Rectangle7.png') 30 30 stretch;
          padding: 1rem 1.25rem;
          width: 14.2rem;
          height: 11.2rem;
          background: rgba(17, 38, 37, 0.5);
          box-shadow: inset 0px 0.1rem 0.3rem #306aba, inset 0.1rem 0px 0.2rem #306aba,
            inset -0.1rem 0px 0.2rem #306aba;

          li {
            list-style: none;
            line-height: 2.25rem;

            span {
              font-size: 1.2rem;
            }

            .index {
              margin-right: 1.2rem;
            }
          }
        }
      }

      .video-box {
        width: 70.9rem;
        height: 58rem;
        #play_window {
          width: 100%;
          height: 100%;
        }
        .video {
          width: 100%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
          }
        }
      }

      .btn-box {
        background: rgba(0, 0, 0, 0.5);

        .btn {
          display: inline-block;
          color: #4fd2ff;
          font-size: 1.3rem;
          padding: 0.5rem 1rem;
          border-radius: 0.1rem;
          margin: 0.6rem 0 0.6rem 1.2rem;
          border: 1px solid #66928acc;
          background: #66928a1a;
          cursor: pointer;
        }

        .active {
          background: #26a1d2;
          color: #ffffff;
        }
      }

      .control {
        position: absolute;
        z-index: 99;
        left: 0px;
        bottom: 4.5rem;
        width: 10rem;
        height: 13rem;
        background: #494949e0;

        .focal {
          display: flex;
          bottom: 0;
          display: flex;
          position: absolute;
          width: 100%;
          border-top: 1px solid #8b8b8b;

          p {
            flex: 1;
            text-align: center;
            font-size: 34px;
            font-weight: 700;
            height: 30px;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
              background-color: #dddddd24;
            }
          }
        }

        span {
          display: inline-block;
          width: 2.6rem;
          height: 2.6rem;
          background-size: cover;
          position: absolute;
          cursor: pointer;

          &:hover {
            background-color: #dddddd29;
          }

          &:nth-child(1) {
            background-image: url('~@/assets/img/map/上.png');
            top: 0.75rem;
            left: 3.7rem;
          }

          &:nth-child(2) {
            background-image: url('~@/assets/img/map/右.png');
            top: 3.7rem;
            right: 0.75rem;
          }

          &:nth-child(3) {
            background-image: url('~@/assets/img/map/下.png');
            left: 3.7rem;
            bottom: 3.75rem;
          }

          &:nth-child(4) {
            background-image: url('~@/assets/img/map/左.png');
            top: 3.7rem;
            left: 0.75rem;
          }
        }
      }

      .multiply {
        position: absolute;
        z-index: 99;
        left: 10rem;
        bottom: 45px;
        width: 72px;
        height: 160px;
        background: #49494963;

        p {
          margin: 0;
          padding: 0.2rem 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background: #ffffff1a;
          }
        }

        .active {
          background: #ffffff26;
          color: #00ffde;
        }
      }
    }

    .right {
      padding: 0 1rem 0 1.5rem;

      .title {
        display: inline-block;
        font-size: 2.4rem;
        color: #ffffff;
        border-bottom: 0.3rem solid #ffffff;
        padding: 1rem 0;
      }

      :deep(.n-data-table) {
        width: 600px;
        --n-border-color-modal: #ffffff00 !important;
        --n-th-color-modal: #ffffff00 !important;
        --n-td-color-hover-modal: #ffffff00 !important;
        --n-td-color-modal: #ffffff00 !important;

        tbody {
          tr:nth-of-type(odd) {
            background: #ffffff0d;
          }

          tr:hover {
            background: #ffffff26;
          }

          .tag {
            color: #000000;
            padding: 0;
            text-align: center;
            width: 4rem;
            border-radius: 0.25rem;
            margin: auto;
            font-size: 1rem;
          }

          .clz {
            background: #ffe3c2;
          }

          .dcl {
            background: #f7d4d4;
          }

          .ywj {
            background: #bfe7ff;
          }
        }
      }
    }
  }
}
</style>
